// Share a selection between desktop and mobile menus for this document.
const selections = new Map();

class RotatingMenuProduct extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    const cards = Array.from(this.querySelectorAll('template[data-product-id]'));
    const slot = this.querySelector('[data-product-slot]');
    if (!cards.length || !slot) return;

    const key = this.dataset.selectionKey;
    const storageKey = `water-star-menu-product:${key}`;
    let chosen = selections.get(key);
    if (!cards.some(card => card.dataset.productId === chosen)) {
      let previous;
      try { previous = sessionStorage.getItem(storageKey); } catch { /* Storage is optional. */ }
      const alternatives = cards.filter(card => card.dataset.productId !== previous);
      const pool = alternatives.length ? alternatives : cards;
      chosen = pool[Math.floor(Math.random() * pool.length)].dataset.productId;
      selections.set(key, chosen);
      try { sessionStorage.setItem(storageKey, chosen); } catch { /* Keep working without storage. */ }
    }
    slot.replaceChildren(cards.find(card => card.dataset.productId === chosen).content.cloneNode(true));
    this.dataset.selectedProduct = chosen;
    this.initialized = true;
  }
}

if (!customElements.get('rotating-menu-product')) {
  customElements.define('rotating-menu-product', RotatingMenuProduct);
}
